import * as React from "react";
import "../styles/tableSection.css";
import { AdContext } from "../context/AdContext";
import { dateFormat } from "../components/commonComponents";

const HeaderSection = () => {
  const { group, resources } = React.useContext(AdContext);
  return (
    <div className="group-container">
      <div className="group-wrapper">
        <div className="group-row">
          <div className="group-card">
            <div className="group-card-inner">
              <div className="group-item">
                <div className="group-label">Group Name</div>
                <div className="group-value">{group?.displayName || "NA"}</div>
              </div>
              <div className="group-item">
                <div className="group-label">Created on</div>
                <div className="group-value">{dateFormat(group?.createdDateTime || "") || "NA"}</div>
              </div>
            </div>
          </div>
          <div className="group-card">
            <div className="group-card-inner">
              <div className="group-item">
                <div className="group-label">Total Members</div>
                <div className="group-value">{String(resources).padStart(2, "0")}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="description-card">
          <div className="description-row">
            <span className="desc-title">Description: - </span>
            <span className="desc-text">{group?.description || "NA"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
